import React from 'react';
import { SiPlaystation, SiBookstack } from 'react-icons/si';

const NowSection = () => {
  const games = ["Baldur's Gate 3", 'Life is Strange - Double Exposure'];
  const books = [
    'More Days At The Morisaki Bookshop',
    "Emily Wilde's Compendium of Lost Tales",
  ];
  const now = new Date().toLocaleDateString();

  return (
    <section className="mt-8 md:mt-10">
      {/* Title matches site motif */}
      <h3 className="flex items-center gap-2 text-xl font-semibold text-black">
        <span
          className="inline-block h-2.5 w-2.5 rounded-full bg-teal-600"
          aria-hidden="true"
        />
        What I’m enjoying lately
      </h3>

      {/* Cards */}
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {/* Games */}
        <div className="h-full rounded-2xl border border-gray-200 bg-white/80 p-5 shadow-sm backdrop-blur-sm">
          <div className="mb-2 flex items-center gap-2">
            <SiPlaystation className="text-teal-600" />
            <h4 className="text-sm font-semibold text-gray-900">
              Games I’m playing
            </h4>
          </div>
          <ul className="space-y-1 text-sm text-gray-700">
            {games.map((g) => (
              <li key={g} className="flex items-center gap-2">
                <span aria-hidden="true">🎮</span>
                <span>{g}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Books */}
        <div className="h-full rounded-2xl border border-gray-200 bg-white/80 p-5 shadow-sm backdrop-blur-sm">
          <div className="mb-2 flex items-center gap-2">
            <SiBookstack className="text-teal-600" />
            <h4 className="text-sm font-semibold text-gray-900">
              Books I’m reading
            </h4>
          </div>
          <ul className="space-y-1 text-sm text-gray-700">
            {books.map((b) => (
              <li key={b} className="flex items-center gap-2">
                <span aria-hidden="true">📚</span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Subtle meta */}
      <p className="mt-3 text-xs text-gray-500"> {now} ✨</p>
    </section>
  );
};

export default NowSection;
